<div *appIconHost></div>
